module.exports = __webpack_public_path__ + "img/full6-min.2470d82c.png";